import Vue from 'vue'
import VueI18n from 'vue-i18n'
import en from '@/utils/langs/english.json'  //English
import da from '@/utils/langs/danish.json'  //Danish - Denmark
import ar from '@/utils/langs/arabic.json'  //Danish - Denmark
import be from '@/utils/langs/bengali.json'  //Danish - Denmark
import ch from '@/utils/langs/chinese.json'  //Danish - Denmark
import hi from '@/utils/langs/hindustani.json'  //Danish - Denmark
import ma from '@/utils/langs/malay.json'  //Danish - Denmark
import ru from '@/utils/langs/russian.json'  //Danish - Denmark
import ta from '@/utils/langs/tamil.json'  //Danish - Denmark

Vue.use(VueI18n)

export const i18n=new VueI18n({
  locale:'en',
  fallbackLocale:'en',
  messages:{
    en,
    da,
    ar,
    be,
    ch,
    hi,
    ma,
    ru,
    ta
  }
})

// below function is used to set the language
// setLocale(language=='en'){
//   this.i18n.locale=language
// }



// WEBPACK FOOTER //
// ./src/utils/i18n.js